import React from "react";
import { Pencil, X } from "lucide-react";
import { useIntl } from "react-intl";
import DrawingToolIcon from "../DrawingToolIcon";
import { drawingToolLabelId } from "../drawingToolLabels";
import "./CurrentDrawings.sass";

const ICON_SIZE = 16;
const ACTION_ICON_SIZE = 14;

/**
 * The Current tab: the drawings of the chart in the order they were drawn,
 * each with ✏️ that opens its settings and ✕ that removes it. A hidden one
 * stays on the list as it is: its settings are the way to show it again.
 *
 * @param {object}   props
 * @param {object[]} props.drawings - engine.getDrawings() items
 * @param {(id: string) => void} props.onEdit
 * @param {(id: string) => void} props.onRemove
 */
const CurrentDrawings = ({ drawings, onEdit, onRemove }) => {
  const intl = useIntl();
  const editLabel = intl.formatMessage({ id: "futures.chart.drawing_toolbar.settings" });
  const removeLabel = intl.formatMessage({ id: "futures.chart.drawings.remove" });

  return (
    <ul className="current-drawings">
      {drawings.map(({ id, type }) => {
        const label = intl.formatMessage({ id: drawingToolLabelId(type) });

        return (
          <li key={id} className="current-drawings__item">
            <DrawingToolIcon toolId={type} size={ICON_SIZE} />
            <span className="current-drawings__name" title={label}>
              {label}
            </span>
            <button
              type="button"
              className="current-drawings__action"
              aria-label={`${editLabel} ${label}`}
              title={editLabel}
              onClick={() => onEdit(id)}
            >
              <Pencil size={ACTION_ICON_SIZE} aria-hidden="true" />
            </button>
            <button
              type="button"
              className="current-drawings__action"
              aria-label={`${removeLabel} ${label}`}
              title={removeLabel}
              onClick={() => onRemove(id)}
            >
              <X size={ACTION_ICON_SIZE} aria-hidden="true" />
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default CurrentDrawings;
